import 'slick-carousel';

export default {
  init() {
    // JavaScript to be fired on all pages
    var header = $('.banner');
    $(window).scroll(function() {
      var scroll = $(window).scrollTop();
      if (scroll >= 80) {
        header.addClass('nav-fixed');
      } else {
        header.removeClass('nav-fixed');
      }
    });

    $('.slider').slick({
      dots: false,
      infinite: true,
      arrows: true,
      speed: 2500,
      fade: true,
      autoplay: true,
    });

    $('.gallery').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      speed: 1000,
      autoplay: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      responsive: [
        {
          breakpoint: 720,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    });

    // $('.slide-left').slick({
    //   infinite: true,
    //   slidesToShow: 2,
    //   slidesToScroll: 1,
    //   dots: false,
    //   arrows: false,
    //   speed: 2500,
    //   autoplay: true,
    //   pauseOnFocus: false,
    //   pauseOnHover: false,
    //   responsive: [
    //     {
    //       breakpoint: 720,
    //       settings: {
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //       },
    //     },
    //   ],
    // });

    // $('.slide-right').slick({
    //   infinite: true,
    //   slidesToShow: 2,
    //   slidesToScroll: 1,
    //   dots: false,
    //   arrows: false,
    //   speed: 2500,
    //   autoplay: true,
    //   pauseOnFocus: false,
    //   pauseOnHover: false,
    //   rtl: true,
    //   responsive: [
    //     {
    //       breakpoint: 720,
    //       settings: {
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //       },
    //     },
    //   ],
    // });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js